// extracted by mini-css-extract-plugin
export default {"host":"DesktopAppLayout_host__CQScM","leftNav":"DesktopAppLayout_leftNav__GRjaY","thinNav":"DesktopAppLayout_thinNav__KL2zh","mainContent":"DesktopAppLayout_mainContent__oUmT0"};